import { usePocMutation } from 'core/custom-hooks/use-poc-mutation.hook';
import { useTranslation } from 'core/i18n/i18n';
import { materialDefinitionKeys } from 'core/query-client/keys';
import { updateQuery } from 'core/query-client/query-client';
import { showErrorNotification, showSuccessNotification } from 'core/utils/notification-service';
import { classifyMaterialDefinitionApiError } from 'modules/settings/pods/settings-materials/service/material-definitions/material-definitions.business';
import { deleteMaterialDefinition } from 'modules/settings/pods/settings-materials/service/material-definitions/material-definitions.service';
import { DELETE_MATERIAL_KEY } from '../components/delete-material-confirmation/delete-material-confirmation.constants';

export const useMaterialDefinitionDeleter = () => {
    const { t } = useTranslation();

    const deleteMutation = usePocMutation({
        mutationFn: (id: string) => deleteMaterialDefinition(id),
        onSuccess: () => {
            updateQuery(materialDefinitionKeys.all);
            showSuccessNotification(t(DELETE_MATERIAL_KEY.notification.success));
        },
        onError: (error) => {
            const messageKey =
                classifyMaterialDefinitionApiError(error) === 'in-use'
                    ? DELETE_MATERIAL_KEY.notification.errorInUse
                    : DELETE_MATERIAL_KEY.notification.error;
            showErrorNotification(t(messageKey));
        },
    });

    return {
        deleteMaterial: (id: string) => deleteMutation.mutateAsync(id),
        isDeleting: deleteMutation.isPending,
    };
};
